import { useState } from "react"
import { tradeCards } from "../../data/data"

export default function TradeCards() {
  const [cards] = useState(tradeCards)

  return (
    <>
      <section className="px-5 2xl:px-0 grid grid-cols-1 gap-10 sm:grid-cols-2 md:grid-cols-3 lg:max-w-4xl lg:mx-auto py-10 lg:py-20">
        {cards.map(({ id, title, image }) => (
          <article key={id} className="md:w-52">
            <img
              src={image}
              alt={title}
              title={title}
              className="block mx-auto w-20"
            />
            <h4 className="text-gray-800 text-xl uppercase text-center mt-3">
              {title}
            </h4>
          </article>
        ))}
      </section>
    </>
  )
}
